import React, { useState, useRef, useEffect } from "react";
import ManageInstructors from "./ManageInstructors";
import ManageStudents from "./ManageStudents";
import "../../../../App.css";

const TAB_KEY = "manageUsersActiveTab";

const ManageUsers = () => {
  const [activeTab, setActiveTab] = useState(() => localStorage.getItem(TAB_KEY) || "instructors");
  const instructorsRef = useRef();
  const studentsRef = useRef();

  useEffect(() => {
      localStorage.setItem(TAB_KEY, activeTab);
    }, [activeTab]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "instructors":
        return <ManageInstructors ref={instructorsRef} />;
      case "students":
        return <ManageStudents ref={studentsRef} />;
      default:
        return null;
    }
  };

  return (
    <div className="manage-academics-container">
      <div className="tabs">
        <button
          className={`tab-btn ${activeTab === "instructors" ? "active" : ""}`}
          onClick={() => setActiveTab("instructors")}
        >
          Instructors
        </button>
        <button
          className={`tab-btn ${activeTab === "students" ? "active" : ""}`}
          onClick={() => setActiveTab("students")}
        >
          Students
        </button>
      </div>

      <div className="tab-content">{renderActiveTab()}</div>
    </div>
  );
};

export default ManageUsers;